// extracted by mini-css-extract-plugin
module.exports = {"myRoomViewWrapper":"PressRoomView_myRoomViewWrapper__H195E"};